// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o6X2","left":"styles_left__q6qaj"};